function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["repeat", "spec"],
  _excluded2 = ["repeat", "spec", "data"],
  _excluded3 = ["row", "column", "facet"],
  _excluded4 = ["mark", "width", "projection", "height", "view", "params", "encoding"],
  _excluded5 = ["align", "center", "spacing", "columns"],
  _excluded6 = ["align", "center", "spacing", "columns"],
  _excluded7 = ["parentEncoding", "parentProjection"],
  _excluded8 = ["encoding", "projection"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { isArray } from 'vega-util';
import { COLUMN, FACET, ROW } from '../channel';
import { hasConditionalFieldOrDatumDef, isFieldOrDatumDef, isValueDef } from '../channeldef';
import { boxPlotNormalizer } from '../compositemark/boxplot';
import { errorBandNormalizer } from '../compositemark/errorband';
import { errorBarNormalizer } from '../compositemark/errorbar';
import { channelHasField } from '../encoding';
import * as log from '../log';
import { isFacetMapping } from '../spec/facet';
import { SpecMapper } from '../spec/map';
import { isLayerRepeatSpec } from '../spec/repeat';
import { isUnitSpec } from '../spec/unit';
import { isEmpty, keys, omit, varName } from '../util';
import { isSignalRef } from '../vega.schema';
import { PathOverlayNormalizer } from './pathoverlay';
import { replaceRepeaterInEncoding, replaceRepeaterInFacet } from './repeater';
import { RuleForRangedLineNormalizer } from './ruleforrangedline';
export var CoreNormalizer = /*#__PURE__*/function (_SpecMapper) {
  function CoreNormalizer() {
    var _this;
    _classCallCheck(this, CoreNormalizer);
    _this = _callSuper(this, CoreNormalizer, arguments);
    _this.nonFacetUnitNormalizers = [boxPlotNormalizer, errorBarNormalizer, errorBandNormalizer, new PathOverlayNormalizer(), new RuleForRangedLineNormalizer()];
    return _this;
  }
  _inherits(CoreNormalizer, _SpecMapper);
  return _createClass(CoreNormalizer, [{
    key: "map",
    value: function map(spec, params) {
      // Special handling for a faceted unit spec as it can return a facet spec, not just a layer or unit spec like a normal unit spec.
      if (isUnitSpec(spec)) {
        var hasRow = channelHasField(spec.encoding, ROW);
        var hasColumn = channelHasField(spec.encoding, COLUMN);
        var hasFacet = channelHasField(spec.encoding, FACET);
        if (hasRow || hasColumn || hasFacet) {
          return this.mapFacetedUnit(spec, params);
        }
      }
      return _superPropGet(CoreNormalizer, "map", this, 3)([spec, params]);
    }
    // This is for normalizing non-facet unit
  }, {
    key: "mapUnit",
    value: function mapUnit(spec, params) {
      var parentEncoding = params.parentEncoding,
        parentProjection = params.parentProjection;
      var encoding = replaceRepeaterInEncoding(spec.encoding, params.repeater);
      var specWithReplacedEncoding = _objectSpread(_objectSpread(_objectSpread({}, spec), spec.name ? {
        name: [params.repeaterPrefix, spec.name].filter(function (n) {
          return n;
        }).join('_')
      } : {}), encoding ? {
        encoding: encoding
      } : {});
      if (parentEncoding || parentProjection) {
        return this.mapUnitWithParentEncodingOrProjection(specWithReplacedEncoding, params);
      }
      var normalizeLayerOrUnit = this.mapLayerOrUnit.bind(this);
      var _iterator = _createForOfIteratorHelper(this.nonFacetUnitNormalizers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var unitNormalizer = _step.value;
          if (unitNormalizer.hasMatchingType(specWithReplacedEncoding, params.config)) {
            return unitNormalizer.run(specWithReplacedEncoding, params, normalizeLayerOrUnit);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return specWithReplacedEncoding;
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      if (isLayerRepeatSpec(spec)) {
        return this.mapLayerRepeat(spec, params);
      } else {
        return this.mapNonLayerRepeat(spec, params);
      }
    }
  }, {
    key: "mapLayerRepeat",
    value: function mapLayerRepeat(spec, params) {
      var _this2 = this;
      var repeat = spec.repeat,
        childSpec = spec.spec,
        rest = _objectWithoutProperties(spec, _excluded);
      var row = repeat.row,
        column = repeat.column,
        layer = repeat.layer;
      var _params$repeater = params.repeater,
        repeater = _params$repeater === void 0 ? {} : _params$repeater,
        _params$repeaterPrefi = params.repeaterPrefix,
        repeaterPrefix = _params$repeaterPrefi === void 0 ? '' : _params$repeaterPrefi;
      if (row || column) {
        return this.mapRepeat(_objectSpread(_objectSpread({}, spec), {}, {
          repeat: _objectSpread(_objectSpread({}, row ? {
            row: row
          } : {}), column ? {
            column: column
          } : {}),
          spec: {
            repeat: {
              layer: layer
            },
            spec: childSpec
          }
        }), params);
      } else {
        return _objectSpread(_objectSpread({}, rest), {}, {
          layer: layer.map(function (layerValue) {
            var childRepeater = _objectSpread(_objectSpread({}, repeater), {}, {
              layer: layerValue
            });
            var childName = "".concat((childSpec.name ? "".concat(childSpec.name, "_") : '') + repeaterPrefix, "child__layer_").concat(varName(layerValue));
            var child = _this2.mapLayerOrUnit(childSpec, _objectSpread(_objectSpread({}, params), {}, {
              repeater: childRepeater,
              repeaterPrefix: childName
            }));
            child.name = childName;
            return child;
          })
        });
      }
    }
  }, {
    key: "mapNonLayerRepeat",
    value: function mapNonLayerRepeat(spec, params) {
      var _childSpec$data;
      var _spec = spec,
        repeat = _spec.repeat,
        childSpec = _spec.spec,
        data = _spec.data,
        remainingProperties = _objectWithoutProperties(_spec, _excluded2);
      if (!isArray(repeat) && spec.columns) {
        // is repeat with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('repeat'));
      }
      var concat = [];
      var _params$repeater2 = params.repeater,
        repeater = _params$repeater2 === void 0 ? {} : _params$repeater2,
        _params$repeaterPrefi2 = params.repeaterPrefix,
        repeaterPrefix = _params$repeaterPrefi2 === void 0 ? '' : _params$repeaterPrefi2;
      var row = !isArray(repeat) && repeat.row || [repeater ? repeater.row : null];
      var column = !isArray(repeat) && repeat.column || [repeater ? repeater.column : null];
      var repeatValues = isArray(repeat) && repeat || [repeater ? repeater.repeat : null];
      // cross product
      var _iterator2 = _createForOfIteratorHelper(repeatValues),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var repeatValue = _step2.value;
          var _iterator3 = _createForOfIteratorHelper(row),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var rowValue = _step3.value;
              var _iterator4 = _createForOfIteratorHelper(column),
                _step4;
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  var columnValue = _step4.value;
                  var childRepeater = {
                    repeat: repeatValue,
                    row: rowValue,
                    column: columnValue,
                    layer: repeater.layer
                  };
                  var childName = (childSpec.name ? "".concat(childSpec.name, "_") : '') + repeaterPrefix + 'child__' + (isArray(repeat) ? "".concat(varName(repeatValue)) : (repeat.row ? "row_".concat(varName(rowValue)) : '') + (repeat.column ? "column_".concat(varName(columnValue)) : ''));
                  var child = this.map(childSpec, _objectSpread(_objectSpread({}, params), {}, {
                    repeater: childRepeater,
                    repeaterPrefix: childName
                  }));
                  child.name = childName;
                  // we move data up
                  concat.push(omit(child, ['data']));
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var columns = isArray(repeat) ? spec.columns : repeat.column ? repeat.column.length : 1;
      return _objectSpread(_objectSpread({
        data: (_childSpec$data = childSpec.data) !== null && _childSpec$data !== void 0 ? _childSpec$data : data,
        // data from child spec should have precedence
        align: 'all'
      }, remainingProperties), {}, {
        columns: columns,
        concat: concat
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      var _spec2 = spec,
        facet = _spec2.facet;
      if (isFacetMapping(facet) && spec.columns) {
        // is facet with row/column
        spec = omit(spec, ['columns']);
        log.warn(log.message.columnsNotSupportByRowCol('facet'));
      }
      return _superPropGet(CoreNormalizer, "mapFacet", this, 3)([spec, params]);
    }
  }, {
    key: "mapUnitWithParentEncodingOrProjection",
    value: function mapUnitWithParentEncodingOrProjection(spec, params) {
      var encoding = spec.encoding,
        projection = spec.projection;
      var parentEncoding = params.parentEncoding,
        parentProjection = params.parentProjection,
        config = params.config;
      var mergedProjection = mergeProjection({
        parentProjection: parentProjection,
        projection: projection
      });
      var mergedEncoding = mergeEncoding({
        parentEncoding: parentEncoding,
        encoding: replaceRepeaterInEncoding(encoding, params.repeater)
      });
      return this.mapUnit(_objectSpread(_objectSpread(_objectSpread({}, spec), mergedProjection ? {
        projection: mergedProjection
      } : {}), mergedEncoding ? {
        encoding: mergedEncoding
      } : {}), {
        config: config
      });
    }
  }, {
    key: "mapFacetedUnit",
    value: function mapFacetedUnit(spec, normParams) {
      // New encoding in the inside spec should not contain row / column
      // as row/column should be moved to facet
      var _spec$encoding = spec.encoding,
        row = _spec$encoding.row,
        column = _spec$encoding.column,
        facet = _spec$encoding.facet,
        encoding = _objectWithoutProperties(_spec$encoding, _excluded3);
      // Mark and encoding should be moved into the inner spec
      var mark = spec.mark,
        width = spec.width,
        projection = spec.projection,
        height = spec.height,
        view = spec.view,
        params = spec.params,
        _ = spec.encoding,
        outerSpec = _objectWithoutProperties(spec, _excluded4);
      var _this$getFacetMapping = this.getFacetMappingAndLayout({
          row: row,
          column: column,
          facet: facet
        }, normParams),
        facetMapping = _this$getFacetMapping.facetMapping,
        layout = _this$getFacetMapping.layout;
      var newEncoding = replaceRepeaterInEncoding(encoding, normParams.repeater);
      return this.mapFacet(_objectSpread(_objectSpread(_objectSpread({}, outerSpec), layout), {}, {
        // row / column has higher precedence than facet
        facet: facetMapping,
        spec: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, width ? {
          width: width
        } : {}), height ? {
          height: height
        } : {}), view ? {
          view: view
        } : {}), projection ? {
          projection: projection
        } : {}), {}, {
          mark: mark,
          encoding: newEncoding
        }, params ? {
          params: params
        } : {})
      }), normParams);
    }
  }, {
    key: "getFacetMappingAndLayout",
    value: function getFacetMappingAndLayout(facets, params) {
      var row = facets.row,
        column = facets.column,
        facet = facets.facet;
      if (row || column) {
        if (facet) {
          log.warn(log.message.facetChannelDropped([].concat(_toConsumableArray(row ? [ROW] : []), _toConsumableArray(column ? [COLUMN] : []))));
        }
        var facetMapping = {};
        var layout = {};
        for (var _i = 0, _arr = [ROW, COLUMN]; _i < _arr.length; _i++) {
          var channel = _arr[_i];
          var def = facets[channel];
          if (def) {
            var align = def.align,
              center = def.center,
              spacing = def.spacing,
              columns = def.columns,
              defWithoutLayout = _objectWithoutProperties(def, _excluded5);
            facetMapping[channel] = defWithoutLayout;
            for (var _i2 = 0, _arr2 = ['align', 'center', 'spacing']; _i2 < _arr2.length; _i2++) {
              var prop = _arr2[_i2];
              if (def[prop] !== undefined) {
                var _layout$prop;
                (_layout$prop = layout[prop]) !== null && _layout$prop !== void 0 ? _layout$prop : layout[prop] = {};
                layout[prop][channel] = def[prop];
              }
            }
          }
        }
        return {
          facetMapping: facetMapping,
          layout: layout
        };
      } else {
        var _align = facet.align,
          _center = facet.center,
          _spacing = facet.spacing,
          _columns = facet.columns,
          _facetMapping = _objectWithoutProperties(facet, _excluded6);
        return {
          facetMapping: replaceRepeaterInFacet(_facetMapping, params.repeater),
          layout: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _align ? {
            align: _align
          } : {}), _center ? {
            center: _center
          } : {}), _spacing ? {
            spacing: _spacing
          } : {}), _columns ? {
            columns: _columns
          } : {})
        };
      }
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, _ref) {
      var parentEncoding = _ref.parentEncoding,
        parentProjection = _ref.parentProjection,
        otherParams = _objectWithoutProperties(_ref, _excluded7);
      // Special handling for extended layer spec
      var encoding = spec.encoding,
        projection = spec.projection,
        rest = _objectWithoutProperties(spec, _excluded8);
      var params = _objectSpread(_objectSpread({}, otherParams), {}, {
        parentEncoding: mergeEncoding({
          parentEncoding: parentEncoding,
          encoding: encoding,
          layer: true
        }),
        parentProjection: mergeProjection({
          parentProjection: parentProjection,
          projection: projection
        })
      });
      return _superPropGet(CoreNormalizer, "mapLayer", this, 3)([_objectSpread(_objectSpread({}, rest), spec.name ? {
        name: [params.repeaterPrefix, spec.name].filter(function (n) {
          return n;
        }).join('_')
      } : {}), params]);
    }
  }]);
}(SpecMapper);
function mergeEncoding(_ref2) {
  var parentEncoding = _ref2.parentEncoding,
    _ref2$encoding = _ref2.encoding,
    encoding = _ref2$encoding === void 0 ? {} : _ref2$encoding,
    layer = _ref2.layer;
  var merged = {};
  if (parentEncoding) {
    var channels = new Set([].concat(_toConsumableArray(keys(parentEncoding)), _toConsumableArray(keys(encoding))));
    var _iterator5 = _createForOfIteratorHelper(channels),
      _step5;
    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var channel = _step5.value;
        var channelDef = encoding[channel];
        var parentChannelDef = parentEncoding[channel];
        if (isFieldOrDatumDef(channelDef)) {
          // Field/Datum Def can inherit properties from its parent
          // Note that parentChannelDef doesn't have to be a field/datum def if the channelDef is already one.
          var mergedChannelDef = _objectSpread(_objectSpread({}, parentChannelDef), channelDef);
          merged[channel] = mergedChannelDef;
        } else if (hasConditionalFieldOrDatumDef(channelDef)) {
          merged[channel] = _objectSpread(_objectSpread({}, channelDef), {}, {
            condition: _objectSpread(_objectSpread({}, parentChannelDef), channelDef.condition)
          });
        } else if (channelDef || channelDef === null) {
          merged[channel] = channelDef;
        } else if (layer || isValueDef(parentChannelDef) || isSignalRef(parentChannelDef) || isFieldOrDatumDef(parentChannelDef) || isArray(parentChannelDef)) {
          merged[channel] = parentChannelDef;
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  } else {
    merged = encoding;
  }
  return !merged || isEmpty(merged) ? undefined : merged;
}
function mergeProjection(opt) {
  var parentProjection = opt.parentProjection,
    projection = opt.projection;
  if (parentProjection && projection) {
    log.warn(log.message.projectionOverridden({
      parentProjection: parentProjection,
      projection: projection
    }));
  }
  return projection !== null && projection !== void 0 ? projection : parentProjection;
}